import React, { Component } from 'react';
import PropTypes from 'prop-types';
import API_URL from '../../../../common/url';
import HeaderBar from '../../components/HeaderBar';
import TablePage from './TablePage';
import ChartsCollection from '../components/ChartsCollection';

const countType = 1;
const Icons = [{ icon: '\ue656', order: 0 }, { icon: '\ue659', order: 1 }, { icon: '\ue651', order: 2 }];
function getCharts(type, angle) {
    const chartTitle = angle === '0' ? '发票金额(含税总额)总金额' : '请款笔数';
    return (
        [{
            title: '超出milestone天数',
            chartTitle,
            type,
            key: 'overMilestoneDay',
            queryUrl: API_URL.requestDataAnalysis.queryOutCashReqNodeDaysCount,
            exportUrl: API_URL.requestDataAnalysis.exportOutCashReqNodeDaysCount,
        }, {
            title: '原因分类',
            chartTitle,
            type,
            key: 'reasonClassify',
            queryUrl: API_URL.requestDataAnalysis.queryRemark,
            exportUrl: API_URL.requestDataAnalysis.exportRemark,
        }, {
            title: '客户',
            chartTitle,
            type,
            key: 'client',
            queryUrl: API_URL.requestDataAnalysis.queryCustomer,
            exportUrl: API_URL.requestDataAnalysis.exportCustomer,
        }]
    );
};
const year = new Date().getFullYear();
const beginOfYear = `${year}-01-01`;
const endOfYear = `${year}-12-31`;

class InvoiceData extends Component {
    static contextTypes = {
        businessList: PropTypes.array,
        clientHeight: PropTypes.number,
        notice: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            searchParams: {
                type: '0',
                invoiceDateStart: beginOfYear,
                invoiceDateEnd: endOfYear,
            },
        };
    }

    handleIconChange = (current) => {
        this.setState({ current });
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    render() {
        const { businessList, clientHeight, notice } = this.context;
        const { current, searchParams } = this.state;
        const { type } = searchParams;

        return (
            <div className="pane-item">
                <HeaderBar
                    title="开票数据分析"
                    tip="系统中已开票的请款记录"
                    onChange={this.handleIconChange}
                    current={current}
                    icons={Icons}
                />
                {
                    current === 0 &&
                    <ChartsCollection
                        countType={countType}
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                        charts={getCharts('pie', type)}
                    />
                }
                {
                    current === 1 &&
                    <TablePage
                        notice={notice}
                        searchParams={searchParams}
                        businessList={businessList}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                    />
                }
                {
                    current === 2 &&
                    <ChartsCollection
                        countType={countType}
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                        charts={getCharts('histogram', type)}
                    />
                }
            </div>
        );
    }
}

export default InvoiceData;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/InvoiceData/index.js